import { useEffect, useState } from "react";
import "./Noticias.css";
import { Link } from "react-router-dom";

const Noticias = () => {
  const [posts, setPosts] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    fetch("/api/posts")
      .then(async (res) => {
        if (!res.ok) {
          throw new Error(`Error HTTP ${res.status}`);
        }

        const data = await res.json();

        if (!Array.isArray(data)) {
          setPosts([]);
          return;
        }

        setPosts(data);
      })
      .catch((error) => {
        console.error("Error al cargar posts:", error);
        setPosts([]);
      })
      .finally(() => {
        setCargando(false);
      });
  }, []);

  if (cargando) {
    return <p className="noticias-loading">Cargando noticias...</p>;
  }

  return (
    <section className="noticias-section">
      <div className="noticias-header">
        <span>📰 NOVEDADES</span>
        <h2>Últimas Noticias</h2>
        <p>Entérate de los anuncios, eventos y cambios del servidor.</p>
      </div>

      {posts.length === 0 ? (
        <p className="noticias-empty">
          Todavía no hay noticias publicadas.
        </p>
      ) : (
        <div className="noticias-grid">
          {posts.map((post) => (
            <article className="noticia-card" key={post.id}>
              <div className="noticia-img">
                <img src={post.imagenPortada} alt={post.titulo} />
              </div>

              <div className="noticia-body">
                <span className="noticia-fecha">
                  {post.creadoEn
                    ? new Date(post.creadoEn).toLocaleDateString("es-PE")
                    : ""}
                </span>

                <h3>{post.titulo}</h3>
                <p>{post.resumen}</p>

                <Link
                  to={`/noticias/${post.slug}`}
                  className="noticia-btn"
                >
                  Leer más
                </Link>
              </div>
            </article>
          ))}
        </div>
      )}
    </section>
  );
};

export default Noticias;